import Joi from 'joi';

export const createLayout = () => ({
    name: { label: 'Name', control: 'text' },
    remarks: { label: 'Remarks', control: 'text' },
});

export const createSchema = () => {
    const layout = createLayout();
    return {
        name: Joi.string().max(256).required().label(layout.name.label),
        remarks: Joi.string().max(2000).allow(null, '').label(layout.remarks.label),
    };
};

/**
 * @param {object} [packageShape] - defaults name to the package's own name
 * @returns {{name: string, remarks: string}}
 */
export const createEmpty = (packageShape) => ({
    name: packageShape?.name ?? '',
    remarks: '',
});
